export interface APIPermissionViewModel {
    Id: number;
    Name: string;
    Description: string;
    RoleTypePermissions: RoleTypePermission[];
}

export interface RoleTypePermission {
    RoleTypeId: number;
    PermissionId: number;
}

export const APIPermissions = [
    'BULK_FEED_UPLOAD',
    'BULK_UPDATES',
    'BUYER_LOGIN',
    'CREATE_UPDATE_DELETE_BUSINESSDOCUMENT',
    'CREATE_UPDATE_DELETE_BUSINESSDOCUMENTFLIP',
    'CREATE_UPDATE_DELETE_BUSINESSDOCUMENTSEARCH',
    'CREATE_UPDATE_DELETE_BUYER_ERP_CONNECTION',
    'CREATE_UPDATE_DELETE_BUYERDOCUMENT_MESSAGING',
    'CREATE_UPDATE_DELETE_BUYERSUBMISSIONMETHOD',
    'CREATE_UPDATE_DELETE_COMPANY',
    'CREATE_UPDATE_DELETE_COMPANYDATAPURGE',
    'CREATE_UPDATE_DELETE_CONFIGURABLE_JSRULES_MAPPING',
    'CREATE_UPDATE_DELETE_CUSTOM_DATASETS',
    'CREATE_UPDATE_DELETE_CUSTOMER',
    'CREATE_UPDATE_DELETE_CUSTOMRULES',
    'CREATE_UPDATE_DELETE_DEPARTMENT',
    'CREATE_UPDATE_DELETE_ERP',
    'CREATE_UPDATE_DELETE_ERP_CONNECTION_PARAM',
    'CREATE_UPDATE_DELETE_ERP_GATEWAY_CONFIGURATION',
    'CREATE_UPDATE_DELETE_GLACCOUNT',
    'CREATE_UPDATE_DELETE_GLACCOUNT_STRUCTURE',
    'CREATE_UPDATE_DELETE_HELPRESOURCE',
    'CREATE_UPDATE_DELETE_HUMANREADABLEXSLT',
    'CREATE_UPDATE_DELETE_ITEMMASTER',
    'CREATE_UPDATE_DELETE_MESSAGE',
    'CREATE_UPDATE_DELETE_ONLINE_HELP',
    'CREATE_UPDATE_DELETE_PROFILES',
    'CREATE_UPDATE_DELETE_REPORT',
    'CREATE_UPDATE_DELETE_TECH_DOCUMENTS',
    'CREATE_UPDATE_DELETE_TRADINGPARTNER',
    'CREATE_UPDATE_DELETE_USER_GROUPS',
    'CREATE_UPDATE_DELETE_USERS',
    'CREATE_UPDATE_DELETE_VALIDATIONFAILURE_DASHBOARDREJECTION_TYPES',
    'CREATE_UPDATE_DELETE_VATARCHIVESERVICE',
    'CREATE_UPDATE_DELETE_VENDOR',
    'CREATE_UPDATE_DELETE_VENDOR_CLASS',
    'CREATE_UPDATE_DELETE_VENDORCREATION',
    'CREATE_UPDATE_DELETE_WORKFLOW',
    'CREATE_UPDATE_DELETE_WORKFLOW_INSTANCE',
    'CREATE_WORKFLOW_DOCUMENT',
    'DOCUMENT_EDIT',
    'DOCUMENT_SEARCH',
    'PURGE_TEST_DATA',
    'READ',
    'READ_FLIP',
    'READ_TRANSCEPTA',
    'RUN_DASHBOARD_REPORT',
    'SUPPLIER_LOGIN',
    'VIEW__BUYER_ERP_CONNECTION',
    'VIEW_BUSINESSDOCUMENT',
    'VIEW_BUSINESSDOCUMENTFLIP',
    'VIEW_BUSINESSDOCUMENTSEARCH',
    'VIEW_CONFIGURABLE_JSRULES_MAPPING',
    'VIEW_CUSTOM_DATASETS',
    'VIEW_CUSTOMER',
    'VIEW_CUSTOMRULES',
    'VIEW_DEPARTMENT',
    'VIEW_ERP',
    'VIEW_GLACCOUNT',
    'VIEW_GLACCOUNT_STRUCTURE',
    'VIEW_HUMANREADABLEXSLT',
    'VIEW_ITEMMASTER',
    'VIEW_ONLINE_HELP',
    'VIEW_PARKINGLOT',
    'VIEW_PROFILES',
    'VIEW_TECH_DOCUMENTS',
    'VIEW_USER_GROUPS',
    'VIEW_USERS',
    'VIEW_VALIDATIONFAILURETYPES',
    'VIEW_VATARCHIVESERVICE',
    'VIEW_VENDOR',
    'VIEW_VENDOR_CLASS',
    'VIEW_WORKFLOW',
    'WORFKLOW_SUPERUSER_APPROVE',
] as const;

export type APIPermission = typeof APIPermissions[number];
